import toPrimitive$1 from './to-primitive.js';
import isSymbol$1 from './is-symbol.js';

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$1; // `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey

var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

export { toPropertyKey as default };
